import React, { useCallback } from 'react';

import { Button, CircularProgress, useMediaQuery, useTheme } from '@material-ui/core';

import { showErrorNotification } from 'src/components/common/Notifications';

const AuthPopup = ({ authUrl, onAuthSuccess, isLoading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const handleAuthLogin = useCallback(() => {
    if (!authUrl) {
      showErrorNotification('Authorization URL is not provided', 4000);
      return;
    }

    const width = isMobile ? 300 : 500;
    const height = isMobile ? 500 : 660;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    const authPopup = window.open(authUrl, 'authPopup', `width=${width},height=${height},top=${top},left=${left}`);

    const popupTick = setInterval(() => {
      if (!authPopup || authPopup.closed || authPopup.closed === undefined) {
        clearInterval(popupTick);

        if (authPopup.opener) {
          authPopup.opener.postMessage({ status: 'authSuccess' }, '*');
          authPopup.close();
        }
        if (onAuthSuccess) onAuthSuccess();
      }
    }, 1000);
  }, [authUrl, onAuthSuccess, isMobile]);

  return (
    <Button onClick={handleAuthLogin} variant="contained" color="primary">
      {isLoading ? <CircularProgress style={{ color: 'white' }} size={24} /> : 'Sync with you account '}
    </Button>
  );
};

export default AuthPopup;
